import { StoreModule } from "@ngrx/store";
import { NgModule } from "@angular/core";
import { SEARCH_FEATURE, searchReducer } from "./search.reducer";

@NgModule({
  imports: [
    StoreModule.forFeature(SEARCH_FEATURE, searchReducer)
  ]
})
export class SearchStoreModule {}
